import { render, staticRenderFns } from "./ContactInfo.vue?vue&type=template&id=4a7df534"
import script from "./ContactInfo.vue?vue&type=script&lang=js"
export * from "./ContactInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a7df534')) {
      api.createRecord('4a7df534', component.options)
    } else {
      api.reload('4a7df534', component.options)
    }
    module.hot.accept("./ContactInfo.vue?vue&type=template&id=4a7df534", function () {
      api.rerender('4a7df534', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/back/Modal/ContactInfo.vue"
export default component.exports